import { createSlice, current } from '@reduxjs/toolkit'
import immutabilityUpdate from 'immutability-helper'

const boardTaskList = createSlice({
    name: 'boardTaskList',
    initialState: {
        list: [],
        list_backup: [],//Список сохраняется перед перемещением задачи. Для возможности вернуть все обратно.
        list_loaded: [], //Список загруженных проектов 
        updatedBoard: false, //Укажет была ли обновлена сортировка. Используется для вывления момента отправки запроса на обновление на BackEnd

        listCheckList: [],//Список чек-листов
        listLabel: [],//Фильтр меток 
    },
    reducers: {
        load(state, action) {
            const id_project = parseInt(action.payload.id_project);

            if (action.payload.list !== null) {
                //state.list = [...state.list.filter(a => a.ID_Project !== id_project), ...action.payload.list].sort((a, b) => a.ID_Board - b.ID_Board || a.Order - b.Order);
                state.list = [...state.list.filter(a => a.ID_Project !== id_project), ...action.payload.list.map((item) => { return { ...item, filter_label: 0, filter_user: 0 } })].sort((a, b) => a.ID_Board - b.ID_Board || a.Order - b.Order);
                state.list_loaded = [...state.list_loaded.filter(a => a.id_project !== id_project), { id_project: id_project }];
            }
        },
        update(state, action) {
            const model = action.payload.model;
            state.list = [...state.list.filter(a => a.ID !== model.ID), { ...model, filter_label: 0, filter_user: 0 }].sort((a, b) => a.ID_Board - b.ID_Board || a.Order - b.Order);
        },
        remove(state, action) {
            const id_task = action.payload.id_task;
            state.list = [...state.list.filter(a => a.ID !== id_task)].sort((a, b) => a.ID_Board - b.ID_Board || a.Order - b.Order);
        },
        //Изменит сортировку
        orderChange(state, action) {
            const dragIndex = action.payload.dragIndex;//Первоначальный индекс элемента
            const hoverIndex = action.payload.hoverIndex;//Индекс куда перемещен элемент
            const id_board_old = action.payload.id_board_old;
            const id_board_new = action.payload.id_board_new;
            const id_project = action.payload.id_project;

            //Если перемещение в пределах одной доски
            if (id_board_old === id_board_new) {

                const list = current(state.list).filter(a => a.ID_Board === id_board_old & a.ID_Project === id_project)

                const list_new = immutabilityUpdate(list, {
                    $splice: [
                        [dragIndex, 1],
                        [hoverIndex, 0, list[dragIndex]],
                    ],
                })

                const list_new_order = list_new.map((item, index) => {
                    return { ...item, Order: index };
                });

                state.list = [...state.list.filter(a => a.ID_Board !== id_board_old), ...list_new_order];
            }
        },
        //Изменит доску задачи
        boardChange(state, action) {
            const id_task = action.payload.id_task;//ИД задачи
            const id_board = action.payload.id_board;//Новая доска
            const id_bord_type = action.payload.id_bord_type;//Тип новой доски 1-Проект/ожидание; 2-В работе; 3-Архив 

            state.list_backup = state.list;
            const list = current(state.list)

            const orders = list.filter(a => a.ID_Board === id_board).map((item) => { return item.Order });
            const max_order = Math.max(...orders)
            const min_order = Math.min(...orders)

            const list_new_1 = list.map(item => {
                if (item.ID == id_task) {
                    if (id_bord_type === 3) {
                        return { ...item, ID_Board: id_board, Order: (min_order - 1) };
                    }
                    else {
                        return { ...item, ID_Board: id_board, Order: (max_order + 1) };
                    }
                }
                else {
                    return item;
                }
            });

            state.list = list_new_1.sort((a, b) => a.ID_Board - b.ID_Board || a.Order - b.Order);
            //state.updatedBoard = true;
        },
        //Отмена изменения доски задачи
        boardChangeCancel(state, action) {
            state.list = state.list_backup
        },
        //Запускается после успешного обновления коллекции в BackEnd 
        updatedBoardFalse(state, action) {
            state.updatedBoard = false;
        },
        updatedBoardTrue(state, action) {
            state.updatedBoard = true;
        },
        loadCheckList(state, action) {
            const id_project = action.payload.id_project;
            const list = action.payload.list;

            if (list != null) {
                const list = action.payload.list.map(item => {
                    return { ...item, id_project: id_project }
                })

                state.listCheckList = [...state.listCheckList.filter(a => a.id_project !== id_project), ...list];
            }
        },
        updateCheckList(state, action) {

            const data = action.payload.data;
            const id_task = action.payload.id_task;
            const id_project = current(state.list).filter(a => a.ID === id_task)[0].id_project;
            state.listCheckList = [...state.listCheckList.filter(a => a.ID_Item !== id_task), ...data.map((item) => { return { ...item, id_project: id_project } })];
        },

        loadListLabel(state, action) {
            const id_project = action.payload.id_project;

            const list = action.payload.list;

            if (list != null) {
                const list_ = action.payload.list.map(item => {
                    return { ...item, id_project: id_project }
                })

                state.listLabel = [...state.listLabel.filter(a => a.id_project !== id_project), ...list_];
            }

        },
        updateLabel(state, action) {
            const data = action.payload.data;
            const id_task = action.payload.id_task;
            const id_project = action.payload.id_project;
            state.listLabel = [...state.listLabel.filter(a => a.ID_Item !== id_task), ...data.map((item) => { return { ...item, id_project: id_project } })]
        },
        filterLabel(state, action) {
            const id_project = action.payload.id_project;
            const id_label = action.payload.id_label;

            if (id_label === -1) {
                state.list = state.list.map((item) => {
                    if (item.ID_Project === id_project) {
                        return { ...item, filter_label: 0 }
                    }
                    else {
                        return { ...item }
                    }
                })
            }
            else {
                state.list = state.list.map((item) => {
                    if (item.ID_Project === id_project) {
                        return { ...item, filter_label: state.listLabel.filter(a => a.ID_Project === id_project & a.ID_Label === id_label & a.ID_Item === item.ID).length == 0 ? 1 : 0 }
                    }
                    else {
                        return { ...item }
                    }
                })
            }
        },
        filterUser(state, action) {
            const id_project = action.payload.id_project;
            const id_user = action.payload.id_user;

            state.list = state.list.map((item) => {
                if (item.ID_Project === id_project) {
                    return { ...item, filter_user: 0 }
                }
                else {
                    return { ...item }
                }
            })

            if (id_user === -1) {
                state.list = state.list.map((item) => {
                    if (item.ID_Project === id_project) {
                        return { ...item, filter_user: 0 }
                    }
                    else {
                        return { ...item }
                    }
                })
            }
            else {
                state.list = state.list.map((item) => {
                    if (item.ID_Responsible !== id_user) {
                        return { ...item, filter_user: 1 }
                    }
                    else {
                        return { ...item }
                    }
                })
            }
        },
    }
})

export const { load, update, remove, orderChange, boardChange, boardChangeCancel, updatedBoardFalse, updatedBoardTrue, loadCheckList, updateCheckList, loadListLabel, updateLabel, filterLabel, filterUser } = boardTaskList.actions
export default boardTaskList.reducer